function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1968 7.24456C13.0846 7.39797 10.4127 11.0008 7.00004 11.0008C3.58742 11.0008 0.915311 7.39797 0.80329 7.24471C0.69708 7.09918 0.69708 6.90178 0.80329 6.75625C0.915311 6.60284 3.58742 3.00002 7.00004 3.00002C10.4127 3.00002 13.0846 6.60287 13.1968 6.75613C13.3031 6.90164 13.3031 7.09918 13.1968 7.24456ZM7.00004 3.82768C4.48628 3.82768 2.30911 6.21895 1.66461 7.00069C2.30827 7.78312 4.48089 10.1731 7.00004 10.1731C9.51367 10.1731 11.6907 7.78228 12.3355 7.00012C11.6918 6.21772 9.51919 3.82768 7.00004 3.82768Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.0001 9.48267C5.63099 9.48267 4.51709 8.36876 4.51709 6.99966C4.51709 5.63055 5.63099 4.51665 7.0001 4.51665C8.3692 4.51665 9.48311 5.63055 9.48311 6.99966C9.48311 8.36876 8.3692 9.48267 7.0001 9.48267ZM7.0001 5.34433C6.08731 5.34433 5.34478 6.08689 5.34478 6.99966C5.34478 7.91242 6.08734 8.65498 7.0001 8.65498C7.91286 8.65498 8.65542 7.91242 8.65542 6.99966C8.65542 6.08689 7.91288 5.34433 7.0001 5.34433Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
});

function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.20145e21.svg";
export { ForwardRef as ReactComponent };